import * as React from 'react';
import WizardCard from '../../components/WizardCard/WizardCard';
//import YesNoBtns from '../../components/YesNoBtns/YesNoBtns';
import Appear from '../../components/Appear/Appear';
//import GoogleMap from '../../components/GoogleMap/GoogleMap';
import withContainer from '../../containers/WithContainer';
//import axios from 'axios';
import FormField from '../../components/FormField/FormField';
import { withRouter } from 'react-router-dom';
import Autocomplete from 'react-google-autocomplete';

interface MobileServiceState {
  offersMobileServices: boolean;
  radius: number;
  lat: number;
  lng: number;
  maxDistance: number;
  minAmount: number;
  minDistance: number;
  state: string;
  suburb: string;
  street_address: string;
  postcode: string;
  country: string;
  locationSelected: boolean;
  loadedScript: number;
  selection: string;
}

class MobileService extends React.Component<any, MobileServiceState> {
  public autocomplete;
  autoCompleteRef1: HTMLInputElement | null = null;
  app = this.props.appContainer;

  constructor(props) {
    super(props);
    this.state = {
      offersMobileServices: false,
      radius: 1000,
      lat: this.props.appContainer.state.latLng.lat,
      lng: this.props.appContainer.state.latLng.lng,
      maxDistance: 30,
      minAmount: 0,
      minDistance: 3,
      state: '',
      suburb: '',
      country: '',
      postcode: '',
      street_address: '',
      locationSelected: false,
      loadedScript: 0,
      selection: '',
    };
  }

  handleLocationInputChange = e => {
    this.setState({ ...this.state, ...{ [e.target.name]: e.target.value } });
    this.app.setStep6Address(e.target.value);
  };

  onYes = async () => {
    await this.app.setMobileSelection('yes');
    this.setState({ offersMobileServices: true });
  };

  onNo = async () => {
    this.app.setMobileSelection('no');
  };

  getCurrStep = () => {
    let step = parseInt(this.props.match.path.split('-')[1]);
    return step;
  };

  geocodeLatLng = (lat, lng): any => {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode(
        { location: { lat: lat, lng: lng } },
        (results, status) => {
          if (results && results.length >= 1) {
            let bestResults = results[0];

            for (let r of results) {
              if (
                r.address_components.length >
                bestResults.address_components.length
              ) {
                bestResults = r;
              }
            }
            resolve(bestResults);
          } else {
            reject(status);
          }
        }
      );
    });
  };

  handlePlaceSelect = async addressObject => {
    // Extract City From Address Object
    const lat = addressObject.geometry.location.lat();
    const lng = addressObject.geometry.location.lng();

    let results = await this.geocodeLatLng(lat, lng);

    let postcode;
    let state;
    let suburb;
    let country;
    let countryShort;
    for (let a of results.address_components) {
      if (a.types.includes('country')) {
        country = a.long_name;
        countryShort = a.short_name;
      }
      if (a.types.includes('postal_code')) {
        postcode = a.short_name;
      }
      if (a.types.includes('administrative_area_level_1')) {
        state = a.short_name;
      }
      if (
        this.app.state.provider.country === 'SG' ||
        this.app.state.provider.country === 'sg'
      ) {
        if (a.types.includes('neighborhood')) {
          suburb = a.short_name;
        }
      } else {
        if (a.types.includes('locality')) {
          suburb = a.short_name;
        }
      }
    }

    const newState = {
      street_address: addressObject.formatted_address,
      suburb,
      state,
      postcode,
      country,
      lat: addressObject.geometry.location.lat(),
      lng: addressObject.geometry.location.lng(),
    };
    if (!newState.state && newState.country) newState.state = newState.country;
    await this.app.setStep6State(newState);
    this.setState({
      locationSelected: true,
    });
  };

  handleInputChange = (type, value) => {
    this.setState({ ...this.state, ...{ [type]: value } });
  };

  handleFocus = e => {
    e.target.select();
  };

  onNext = () => {
    this.props.appContainer.step7update(this.getCurrStep());
  };

  public render() {
    let selected;
    if (this.app.state.mobileSelection === 'yes') {
      selected = 'yes';
    } else if (this.app.state.mobileSelection === 'no') {
      selected = 'no';
    } else {
      selected = '';
    }

    const { offersMobileServices } = this.state;
    const { lat, lng } = this.props.appContainer.state.latLng;

    return (
      <WizardCard
        title="Mobile Services. Where are you based?"
        subTitle="Mobile services can help you increase your bookings."
        isDisabled={!this.app.state.step6.postcode}
        onNext={this.onNext}
      >
        <Appear>
          {true && (
            <Appear>
              <FormField
                label="Enter your Location for mobile services"
                htmlFor="location"
                required
              >
                <Autocomplete
                  onPlaceSelected={this.handlePlaceSelect}
                  id="location"
                  type="text"
                  className="input"
                  placeholder="Enter your suburb"
                  types={['(regions)']}
                  value={this.app.state.step6.street_address || ''}
                  onChange={this.handleLocationInputChange}
                  componentRestrictions={{
                    country: 'AU',
                  }}
                />
              </FormField>

              {false && this.state.locationSelected && (
                <>
                  {/* <p className="has-margin-top-45 has-margin-top-20 title is-6">
                    How far are you willing to travel from your suburb?
                  </p>

                  <div className="has-input-inline">
                    <label htmlFor="maxDistance">
                      I am willing to travel
                    </label>
                    &nbsp;
                    <input
                      type="number"
                      className="input input-inline has-width-60"
                      min={1}
                      id="maxDistance"
                      name="max_distance"
                      value={this.props.appContainer.state.step8.max_distance || ''}
                      onChange={this.props.appContainer.handleStep8inputChange}
                    // onFocus={this.handleFocus}
                    />
                    &nbsp;
                <label htmlFor="minAmount">
                      km from home but the job has to be at least $
                </label>
                    &nbsp;
                <input
                      type="number"
                      className="input input-inline has-width-60"
                      id="minAmount"
                      min={0}
                      name="max_distance_job_cost"
                      value={this.props.appContainer.state.step8.max_distance_job_cost || ''}
                      onChange={this.props.appContainer.handleStep8inputChange}
                    // onFocus={this.handleFocus}
                    /> to me
                    &nbsp;
              </div>

                  <hr />
                  <div className="has-input-inline has-margin-top-15">
                    <label htmlFor="minDistance">
                      I am willing to travel upto
                </label>
                    &nbsp;
                <input
                      type="number"
                      className="input input-inline has-width-60"
                      id="minDistance"
                      name="free_distance"
                      value={this.props.appContainer.state.step8.free_distance || ''}
                      onChange={this.props.appContainer.handleStep8inputChange}
                      min={1}
                    // onFocus={this.handleFocus}
                    />
                    &nbsp;
                <span>
                      km from my suburb for any job without needing a minimum job size.
                </span>
                  </div>

                  <div className="columns has-padding-top-15 has-padding-bottom-15 has-margin-top-15">
                    <div style={{ height: 300 }} className="column is-paddingless">
                      <GoogleMap
                        center={{ lat, lng }}
                        zoom={9}
                        circles={[
                          {
                            center: { lat, lng },
                            radius: +this.props.appContainer.state.step8.max_distance * 1000,
                            strokeColor: '#118fe4',
                            fillColor: '#118fe4'
                          },
                          {
                            center: { lat, lng },
                            radius: +this.props.appContainer.state.step8.free_distance * 1000,
                            strokeColor: '#008000',
                            fillColor: '#008000'
                          }
                        ]}
                      />
                    </div>
                  </div> */}
                </>
              )}
            </Appear>
          )}
        </Appear>
      </WizardCard>
    );
  }
}

export default withRouter(withContainer(MobileService));
